// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey:"AIzaSyAHEJLcibjJ3yP_Hz_PJmLvontQayQCXNs",
    authDomain:"arrow-d6ff4.firebaseapp.com",
    projectId:"arrow-d6ff4",
    storageBucket:"arrow-d6ff4.firebasestorage.app",
    messagingSenderId:"1070418485224",
    appId:"1:1070418485224:web:21a74eda2cb4fbad3e4e5d",
    measurementId:"G-N5F3N3ZTE2"// Replace with your actual measurementId value
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;